import {fetchSellers} from "./actions";

export function setloading(state, value) {
    state.loading.module = value;
}
export function setParams(state) {
    state.tableDocuments.params.branchoffice_id = localStorage.selected_branchoffice;
}
export function setWatchDocumument(state, watchDocumument){
    state.watchDocumument = watchDocumument
}
export function setBranchOffices(state, branchoffices) {
    state.branchoffices = branchoffices.map(b => {
        return { value: b.id, label: b.name };
    });
}
export async function setSearchDocuments(state, docs) {
    state.tableDocuments.data = docs;
    if (docs.length > 0) {
        let iva = 0;
        state.documents_products = docs[0].products ? docs[0].products : [];
        await state.documents_products.forEach(item => {
            iva += parseFloat(item.total_value_iva)
        })
        state.tableDocuments.data[0].total_value_iva = iva;
        state.document_files = docs[0].files ? docs[0].files : [] ;
    }

}
export function fetchModelsLite(state, data) {
    state.models_lite = data;
}
export function setAccountsDoc(state, data) {
    state.accounts = data;
}
export function setWarehousesContact(state, data) {
    state.warehousesContacts = data.data;
}
export function setSellers(state, data) {
    state.sellers = data;

}
export function setDocumentProductDeleted(state, data){
    state.deleted = data;
}
export function setDocumentProducts(state, data){
    state.documents_products = data;
}
export function setTypesOperationDocsPro(state, data){
    state.typesOperations = data;
}
export function setProductsDocsPro(state, data){
    state.products = data;
}
export function setDefautlState(state, data){
    state.tableDocuments = {
        data: [],
            columns:[],
            loading: false,
            params: {
            warehouse_id:null,
                vouchertype_id:null,
                prefix :null,
                consecutive :null,
        }
    },
    state.documents_products = [];
    state.default_document_product ={
        id :null,
            index :null,
            product_id :null,
            description :"",
            quantity :0,
            unit_value_before_taxes :0,
            discount_value :0,
            total_value_brut :0,
            total_value_iva :0,
            total_value :0,
            inventory_cost_value :0,
            operationType_id :null,
            fixed_cost :false,
            manage_inventory :true,
            account_id :null,
            center_cost_id :null,
            unit_balance :0,
            value_balance :0,
            backorder_quantity :0,
            backorder_value :0,
            brand_id:null,
            line_id:null,
            subline_id:null,
    }
    state.update_document ={
        id :null,
            branchoffice_id :null,
            vouchertype_id :null,
            prefix :"",
            consecutive :null,
            document_date :null,
            mode_id :null,
            contact_id :null,
            thread :null,
            seller_id :null,
            observation :null,
            account_id :null,
            ret_fue_total :null,
            ret_iva_total :null,
            ret_ica_total :null,
            ret_ica_account_id :null,
            total_value :null,
            documents_information:{
            ret_fte_account_id :null,
        },
        products :[]
    }
    state.document_files_new = [],
    state.document_files_delete = [],
    state.document_files = []
}
export function setDefautlItem(state, data){
    state.default_document_product ={
        id :null,
            index :null,
            product_id :null,
            description :"",
            quantity :0,
            unit_value_before_taxes :0,
            discount_value :0,
            total_value_brut :0,
            total_value_iva :0,
            total_value :0,
            inventory_cost_value :0,
            operationType_id :null,
            fixed_cost :false,
            manage_inventory :true,
            account_id :null,
            center_cost_id :null,
            unit_balance :0,
            value_balance :0,
            backorder_quantity :0,
            backorder_value :0,
            brand_id:null,
            line_id:null,
            subline_id:null,
    }
}
export function setDocumentUpdated(state, document){
    state.update_document = document

    state.update_document.files = state.document_files
    state.update_document.state_backorder = state.update_document.state_backorder? state.update_document.state_backorder.id : null
    state.update_document.products = state.documents_products.map(item => {
        return {
            id: item.id,
            index: item.index,
            product_id: item.product.id,
            branchoffice_warehouse_id: item.branchoffice_warehouse_id ? item.branchoffice_warehouse_id : document.branchoffice_warehouse_id,
            description: item.description,
            quantity: item.quantity,
            unit_value_before_taxes: item.unit_value_before_taxes,
            discount_value: item.discount_value,
            total_value_brut: item.total_value_brut,
            total_value_brut_us: item.total_value_brut_us,
            total_value_iva: item.total_value_iva,
            total_value: item.total_value,
            inventory_cost_value: item.inventory_cost_value,
            operationType_id: item.operationType_id,
            fixed_cost: item.fixed_cost? true : false,
            manage_inventory: item.manage_inventory ? true : false,
            account_id: item.account_id,
            center_cost_id: item.center_cost_id,
            unit_balance: item.unit_balance,
            value_balance: item.value_balance,
            backorder_quantity: item.backorder_quantity,
            backorder_value: item.backorder_value,
            brand_id: item.brand_id,
            subbrand_id: item.subbrand_id,
            line_id: item.line_id,
            subline_id: item.subline_id,
            product_repeat_number: item.product_repeat_number,
            seller_id: item.seller_id? item.seller_id : document.seller_id,

        }
    });
}
export function setUpdateTotals(state){
    if (state.documents_products.length > 0){
        let iva = 0;
        let brut = 0;
        let backQty = 0;
        let backValue = 0;

        state.documents_products.forEach(item =>{
            iva+= parseFloat(item.total_value_iva)
            brut+= parseFloat(item.total_value_brut)
            backQty+= parseFloat(item.backorder_quantity)
            backValue+= parseFloat(item.backorder_value)
        })
        state.tableDocuments.data[0].total_value_iva = iva;
        state.tableDocuments.data[0].total_value_brut = brut;
        state.tableDocuments.data[0].total_value = brut + iva;
        state.tableDocuments.data[0].backorder_quantity = backQty;
        state.tableDocuments.data[0].backorder_value = backValue;
    }
}
export function setStatesBackOrder(state, data){
    state.states_backorder = data;
}
export function setFiscalResponsibilitys(state, data) {
    state.fiscalResponsibilitys = data;
}
export function setBranchofficeWarehousesDocs(state, data){
    state.branchOfficeWarehousesDocs = data;
}
export function setRetentionsDocument(state, data) {

    let document = state.tableDocuments.data[0];

    document.ret_fue_prod_total = data[0].ret_fue_prod_total;
    document.ret_fue_serv_total = data[0].ret_fue_serv_total;
    document.ret_fue_lub_total = data[0].ret_fue_lub_total;
    document.ret_ica_prod_total = data[0].ret_ica_prod_total;
    document.ret_ica_serv_total = data[0].ret_ica_serv_total;
    document.ret_ica_lub_total = data[0].ret_ica_lub_total;

    document.ret_iva_prod_total = data[0].ret_iva_prod_total;
    document.ret_iva_serv_total = data[0].ret_iva_serv_total;
    document.ret_fue_prod_vr_limit = data[0].ret_fue_prod_vr_limit;
    document.ret_fue_prod_percentage = data[0].ret_fue_prod_percentage;

    document.ret_fue_serv_vr_limit = data[0].ret_fue_serv_vr_limit;
    document.ret_fue_serv_percentage = data[0].ret_fue_serv_percentage;
    document.ret_iva_prod_vr_limit = data[0].ret_iva_prod_vr_limit;
    document.ret_iva_prod_percentage = data[0].ret_iva_prod_percentage;

    document.ret_iva_serv_vr_limit = data[0].ret_iva_serv_vr_limit;
    document.ret_iva_serv_percentage = data[0].ret_iva_serv_percentage;
    document.ret_ica_prod_vr_limit = data[0].ret_ica_prod_vr_limit;
    document.ret_ica_prod_percentage = data[0].ret_ica_prod_percentage;

    document.ret_ica_serv_vr_limit = data[0].ret_ica_serv_vr_limit;
    document.ret_ica_serv_percentage = data[0].ret_ica_serv_percentage;
    document.ret_fue_total = data[0].ret_fue_total;
    document.ret_ica_total = data[0].ret_ica_total;
    document.ret_iva_total = data[0].ret_iva_total;

    state.tableDocuments.data = [document]

}
export function setProjectsDocs(state, data) {
    state.projects= data;
}
export async function SetNewTrmValue(state, new_value) {
    state.documents_products=  state.documents_products.map((obj) => {
        return {
            ...obj, // Copia todos los campos existentes del objeto
            total_value_brut: obj.total_value_brut_us * new_value, // Modifica el valor del campo1
            total_value: obj.total_value_us * new_value, // Modifica el valor del campo2
            unit_value_before_taxes: (obj.total_value_brut_us / obj.quantity) * new_value, // Modifica el valor del campo3
        };
    });
}
export async function SetNewTotalValue(state) {
    let total_value_brut = 0;
    let total_value = 0;

    let total_value_brut_us = 0;
    let total_value_us = 0;

    state.documents_products.forEach((obj) => {
        total_value_brut +=  obj.total_value_brut;
        total_value +=  obj.total_value;

        total_value_brut_us +=  obj.total_value_brut_us;
        total_value_us +=  obj.total_value_us;
    });

    state.tableDocuments.data[0].total_value = total_value;
    state.tableDocuments.data[0].total_value_brut = total_value_brut;

    state.tableDocuments.data[0].total_value_us = total_value_us;
    state.tableDocuments.data[0].total_value_brut_us = total_value_brut_us;
}
export function setDocumentFiles(state, data) {
    let extension = data.name.split(".");
    let file = {
        id: null,
        name: data.name,
        extension: extension[extension.length - 1],
        path: "",
        size: data.size,
        sent: false,
        document_id: state.tableDocuments.data[0].id
    };

    state.document_files.push(file);

    state.document_files_new.push(data);
}
export function deleteDocumentFiles(state, data) {
    if (data.id) {
        let key_file = state.document_files.findIndex(
            f => f.id === data.id
        );
        state.document_files.splice(key_file, 1);
        state.document_files_delete.push(data);
    } else {
        let key_file = state.document_files.findIndex(
            f => f.size === data.size && f.name === data.name
        );
        state.document_files.splice(key_file, 1);

        let key_file_new = state.document_files_new.findIndex(
            f => f.size === data.size && f.name === data.name
        );
        state.document_files_new.splice(key_file_new, 1);
    }
}
export function resetDataDocumentFIles(state) {
    state.document_files_new = [];
    state.document_files_delete = [];
}
export function setApplyVat(state, value) {
    state.apply_vat = value;
}
export function setcost_center_1(state, cost_center_1) {
    state.cost_center_1 = cost_center_1;
}




// WEBPACK FOOTER //
// ./src/modules/manage-inventory-documents/mutations.js